import React from 'react';
import moment from 'moment';

const VacationEdit = ({ rec, setFunc, saveFunc, cancelFunc, users }) => {

    const canSave = () => {
        return rec.who != "0" &&
            rec.replace != "0" &&
            rec.fromDate &&
            rec.toDate 
    }

    

    return (
        <>
            <div className="row">
                <div className="col-12">
                    <label>Отсъстващ</label>
                    <select value={rec.who} onChange={(e) => setFunc("who", e.target.value)} className="form-control">
                        <option value="0" key="0"></option>
                        {
                            users.map(item => <option value={item.username} key={item.username}>{item.fullname}</option>)
                        }
                    </select>
                </div>
            </div>
            <div className="row">
                <div className="col-12">
                    <label>Заместващ</label>
                    <select value={rec.replace} onChange={(e) => setFunc("replace", e.target.value)} className="form-control">
                        <option value="0" key="0"></option>
                        {
                            users.map(item => <option value={item.username} key={item.username}>{item.fullname}</option>)
                        }
                    </select>
                </div>
            </div>
            <div className="row">
                <div className="col-12">
                    <label>От дата</label>
                    <input type="date" value={moment(rec.fromDate).format("YYYY-MM-DD")} onChange={(e) => setFunc('fromDate', e.target.value)} className="form-control" />
                </div>

            </div>
            <div className="row">
                <div className="col-12">
                    <label>До дата</label>
                    <input type="date" value={moment(rec.toDate).format("YYYY-MM-DD")} onChange={(e) => setFunc('toDate', e.target.value)} className="form-control" />
                </div>

            </div>
            <div className="row">
                <div className="col-6">
                    {
                        canSave() && <button className="btn btn-primary" onClick={saveFunc}>Запис</button>
                    }

                </div>
                <div className="col-6">
                    <button className="btn btn-warning" onClick={cancelFunc}>Отказ</button>
                </div>

            </div>
        </>
    );
}


export default VacationEdit;

